import { AbstractVisitor } from "./Visitor";
/**
 * Visitor implementation to load all Plugins
 *
 * @public
 */
export class LoadPluginVisitor extends AbstractVisitor {
    constructor(loader) {
        super();
        this.loadingPromises = [];
        this.loader = loader;
    }
    visitPlugin(plugin) {
        if (!this.loader.isLoaded(plugin.plugin)) {
            this.loadingPromises.push(this.loader.load(plugin.plugin));
        }
    }
    reset() {
        this.loadingPromises = [];
    }
    getLoadingPromises() {
        return this.loadingPromises;
    }
}
//# sourceMappingURL=LoadPluginVisitor.js.map